import { createSlice } from '@reduxjs/toolkit';
import {
  fetchCompany,
  updateCompany,
  uploadCompanyLogo,
  fetchPhotographerCompany,
} from '../thunks/company';

const initialState = {
  company: {},
  photos: [],
  showAccountSavedMessage: false,
  originalCompanyValue: {},
  editingKey: '',
  isLogoUploading: false,
  fetching: false,
  fetchError: '',
  saving: false,
  saveError: '',
  errors: {},
};

export const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    updateCompanyData: (state, action) => {
      const { key, value } = action.payload;
      state.company[key] = value;
    },
    setLogoUploading: (state, action) => {
      state.isLogoUploading = action.payload;
    },
    setAccountSavedMessage: (state, action) => {
      state.showAccountSavedMessage = action.payload;
    },
  },
  extraReducers: {
    [fetchCompany.pending]: (state) => {
      state.fetching = true;
    },
    [fetchCompany.fulfilled]: (state, action) => {
      state.fetching = false;
      state.company = action.payload;
    },
    [fetchCompany.rejected]: (state, action) => {
      state.fetching = false;
      state.fetchError = action.payload.error;
    },
    [updateCompany.pending]: (state) => {
      state.saving = true;
    },
    [updateCompany.fulfilled]: (state, action) => {
      state.saving = false;
      state.company = { ...state.company, ...action.payload };
      state.showAccountSavedMessage = true;
    },
    [updateCompany.rejected]: (state, action) => {
      state.saving = false;
      state.saveError = action.payload.error;
      state.errors = action.payload;
    },
    [fetchPhotographerCompany.pending]: (state) => {
      state.fetching = true;
    },
    [fetchPhotographerCompany.fulfilled]: (state, action) => {
      state.fetching = false;
      state.company = action.payload;
      state.originalCompanyValue = action.payload;
    },
    [fetchPhotographerCompany.rejected]: (state, action) => {
      state.fetching = false;
      state.fetchError = action.payload.error;
    },
    [uploadCompanyLogo.pending]: (state) => {
      state.saving = true;
    },
    [uploadCompanyLogo.fulfilled]: (state, action) => {
      state.saving = false;
    },
    [uploadCompanyLogo.rejected]: (state, action) => {
      state.saving = false;
      state.saveError = action.payload.error;
    },
  },
});

export const { updateCompanyData, setLogoUploading, setAccountSavedMessage } =
  companySlice.actions;
